import { gql } from '@apollo/client/index.js'
import { FOOTER_FRAGMENT, footerSchema } from '@ecomm/footer-data'
import { useContentful } from '@ecomm/shared-apollo'

export const CITY_STATE_FOOTER_QUERY = gql`
  ${FOOTER_FRAGMENT}
  query CITY_STATE_FOOTER_QUERY($preview: Boolean!, $locale: String!, $id: String!) {
    footer(id: $id, locale: $locale, preview: $preview) {
      ...footer
    }
  }
`

const useFooterQuery = () => {
  const { data: phoneInNavData } = useContentful(CITY_STATE_FOOTER_QUERY, {
    id: '5AcrNqDwFWOpPA9TfbslCP'
  })

  const footerData = phoneInNavData

  return footerSchema.parse(footerData['footer'])
}

export default useFooterQuery
